/** Values accepted by GET /generated-contracts `status` (matches backend lifecycle set). */
export const GENERATED_CONTRACT_DB_STATUSES: readonly string[] = [
  "draft",
  "generated",
  "finalized",
  "processing",
  "ai_in_progress",
  "processing_failed",
  "pending_review",
  "in_review",
  "completed",
  "review_completed"
] as const;

export function formatGeneratedContractStatusLabel(db: string): string {
  const s = db.trim();
  if (!s) return "";
  return s.replace(/_/g, " ").toUpperCase();
}
